import * as React from 'react';

const NativaPaymentSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={36} height={24} viewBox="0 0 48 32" {...props}>
        <defs>
            <path id="nativa-payment_svg__path-1" d="M0 .023h4.947V8.69H0z" />
            <path
                id="nativa-payment_svg__path-3"
                d="M.041.013h1.8V11.6h-1.8z"
            />
        </defs>
        <g
            id="nativa-payment_svg__Page-1"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <g id="nativa-payment_svg__tarjeta-nativa">
                <path
                    d="M3 31.5C1.6 31.5.5 30.4.5 29V3C.5 1.6 1.6.5 3 .5h42c1.4 0 2.5 1.1 2.5 2.5v26c0 1.4-1.1 2.5-2.5 2.5H3z"
                    fill="#FFF"
                />
                <path
                    d="M45 1c1.1 0 2 .9 2 2v26c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h42zm0-1H3C1.4 0 0 1.4 0 3v26c0 1.6 1.4 3 3 3h42c1.6 0 3-1.4 3-3V3c0-1.6-1.4-3-3-3z"
                    fill="#D2D6DF"
                    fillRule="nonzero"
                />
                <g
                    id="nativa-payment_svg__Group-4"
                    transform="matrix(1.33333 0 0 1.33333 5.333 8)"
                >
                    <g
                        id="nativa-payment_svg__Group-3"
                        transform="translate(0 1.16)"
                    >
                        <mask id="nativa-payment_svg__mask-2" fill="#fff">
                            <use xlinkHref="#nativa-payment_svg__path-1" />
                        </mask>
                        <path
                            d="M4.312.023v2.234L3.04.324l.67 2.152L1.907.896 3.199 2.81.989 1.702 2.793 3.28.337 2.692l2.209 1.11L0 3.787l2.456.588L0 4.927h2.546l-2.21 1.11 2.457-.588L.989 7.027 3.2 5.919 1.907 7.834 3.71 6.256l-.67 2.15 1.272-1.934V8.69l.635-2.082a9.953 9.953 0 01-.264-2.234c0-.74.089-1.49.264-2.25l-.635-2.1z"
                            id="nativa-payment_svg__Fill-1"
                            fill="#F1B800"
                            mask="url(#nativa-payment_svg__mask-2)"
                        />
                    </g>
                    <g
                        id="nativa-payment_svg__Group-6"
                        transform="translate(4.95)"
                    >
                        <mask id="nativa-payment_svg__mask-4" fill="#fff">
                            <use xlinkHref="#nativa-payment_svg__path-3" />
                        </mask>
                        <path
                            d="M.97 1.564l-.125.29A9.856 9.856 0 00.29 3.543a9.96 9.96 0 00-.25 2.282c0 .797.085 1.551.25 2.267.119.532.304 1.096.554 1.686l.124.289c.261.558.551 1.068.873 1.534-.368-.752-.661-1.5-.873-2.25a12.939 12.939 0 01-.498-3.526c0-1.192.165-2.374.498-3.545.212-.749.505-1.503.873-2.266-.299.444-.589.96-.873 1.55"
                            id="nativa-payment_svg__Fill-4"
                            fill="#003772"
                            mask="url(#nativa-payment_svg__mask-4)"
                        />
                    </g>
                    <path
                        d="M9.234 3.58h-.573v4.54h.573V5.268c0-.468.11-.824.328-1.07a.937.937 0 01.72-.3c.599 0 .9.35.9 1.052v3.17h.573V4.917c0-.413-.072-.73-.213-.953-.208-.324-.579-.484-1.114-.484-.458 0-.85.212-1.178.636h-.016V3.58z"
                        id="nativa-payment_svg__Fill-7"
                        fill="#003772"
                    />
                    <path
                        d="M15.37 6.562c0 .307-.133.568-.4.787-.269.23-.584.344-.95.344-.319 0-.563-.088-.733-.261a.32.32 0 01-.053-.067.916.916 0 01-.185-.59c0-.219.063-.4.185-.541.134-.174.345-.294.64-.36l1.497-.115v.803zm-1.92-1.049a5.03 5.03 0 00-.216.067c-.575.216-.86.627-.86 1.227 0 .392.121.71.365.95.134.12.298.214.495.28.181.056.39.083.619.083.681 0 1.193-.213 1.536-.64h.02v.557h.676l-.074-3.375c0-.494-.214-.832-.64-1.017-.244-.109-.592-.165-1.042-.165-.438 0-.804.072-1.095.213a.752.752 0 00-.128.067 1.046 1.046 0 00-.587.918h.694c0-.067.006-.125.02-.181a.615.615 0 01.292-.409c.182-.13.432-.197.75-.197.414 0 .7.099.858.293.158.166.238.422.238.772v.376l-1.92.181z"
                        id="nativa-payment_svg__Fill-9"
                        fill="#003772"
                    />
                    <path
                        d="M17.521 2.32h-.605v1.033h-.83v.44h.83v3.414c0 .305.076.534.225.685.16.151.445.228.847.228l.572-.017v-.49l-.484.033c-.231 0-.38-.05-.45-.157-.071-.105-.105-.316-.105-.63V3.792h1.039v-.44h-1.039V2.32z"
                        id="nativa-payment_svg__Fill-11"
                        fill="#003772"
                    />
                    <path
                        id="nativa-payment_svg__Fill-13"
                        fill="#003772"
                        d="M19.179 8.12h.618V3.48h-.618z"
                    />
                    <path
                        id="nativa-payment_svg__Fill-15"
                        fill="#003772"
                        d="M19.179 2.9h.618v-.58h-.618z"
                    />
                    <path
                        id="nativa-payment_svg__Fill-16"
                        fill="#003772"
                        d="M21.082 3.48h-.666l1.523 4.64h.683l1.506-4.64h-.565l-1.248 3.924h-.02z"
                    />
                    <path
                        d="M26.024 7.693c-.316 0-.566-.088-.75-.261-.158-.166-.235-.385-.235-.657 0-.47.274-.77.821-.902l1.5-.114v.803c0 .307-.127.568-.383.787-.271.23-.587.344-.953.344m1.116-3.509c.146.166.22.422.22.771v.377l-1.92.181c-.72.184-1.08.617-1.08 1.294 0 .392.128.71.384.95.256.243.628.363 1.116.363.682 0 1.188-.213 1.518-.64h.036v.557h.658c-.036-.35-.054-.728-.054-1.131V4.662c0-.787-.568-1.182-1.702-1.182-.51 0-.923.093-1.242.28-.354.195-.541.502-.568.918h.696c0-.264.105-.459.31-.59.182-.13.438-.197.768-.197.402 0 .69.099.86.293"
                        id="nativa-payment_svg__Fill-17"
                        fill="#003772"
                    />
                    <g
                        id="nativa-payment_svg__Group-2"
                        transform="translate(22.04 9.28)"
                        fillRule="nonzero"
                    >
                        <path
                            id="nativa-payment_svg__Path"
                            fill="#F1B800"
                            d="M.102.883L.22.267l.42.616h.03l.163-.85H.735l-.12.625L.193.034h-.03L0 .883z"
                        />
                        <path
                            id="nativa-payment_svg__Combined-Shape"
                            fill="#F1B800"
                            d="M1.062.883l.185-.284h.35l.077.284h.105L1.553 0h-.03l-.57.883z"
                        />
                        <path
                            id="nativa-payment_svg__Path"
                            fill="#FFF"
                            d="M1.571.498h-.258L1.497.21z"
                        />
                        <path
                            d="M2.281.904a.55.55 0 00.41-.177L2.624.668a.448.448 0 01-.31.14c-.11 0-.192-.033-.248-.099a.282.282 0 01-.055-.247.418.418 0 01.153-.25.417.417 0 01.27-.102.3.3 0 01.27.146L2.79.197A.322.322 0 002.656.06a.44.44 0 00-.21-.047.561.561 0 00-.537.44c-.026.13-.004.238.066.323.07.085.172.128.306.128zM3.169.883l.162-.85h-.1l-.162.85z"
                            id="nativa-payment_svg__Path"
                            fill="#F1B800"
                        />
                        <path
                            d="M4.145.013a.4.4 0 01.218.058c.062.04.106.093.133.162a.401.401 0 01.017.225.57.57 0 01-.296.387.508.508 0 01-.236.059.394.394 0 01-.214-.059.322.322 0 01-.133-.161.402.402 0 01-.016-.224.57.57 0 01.295-.388.5.5 0 01.232-.06zM4.13.11a.393.393 0 00-.263.102.425.425 0 00-.146.247c-.018.097 0 .179.054.246a.27.27 0 00.222.101.405.405 0 00.264-.098.413.413 0 00.148-.247.29.29 0 00-.054-.25.274.274 0 00-.225-.1z"
                            id="nativa-payment_svg__Combined-Shape"
                            fill="#F1B800"
                        />
                        <path
                            id="nativa-payment_svg__Path"
                            fill="#F1B800"
                            d="M4.742.883L4.86.267l.42.616h.03l.163-.85h-.098l-.12.625-.422-.624h-.03L4.64.883z"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

NativaPaymentSvg.displayName = 'NativaPaymentSvg';
export default NativaPaymentSvg;
